import { SectionHeader } from "../SectionHeader";
import ThemeChip from "../ThemeChip";
import { fmtCr } from "../../utils/format";

export function POWorkload({ poWorkload }) {
  if (!poWorkload.length) return null;
  return (
    <SectionHeader title="Programme Officer Workload" subtitle="Portfolio distribution — grants, allocation, and KPI performance per PO" collapsible defaultOpen={false}>
      <div className="overflow-x-auto" data-testid="po-workload-section">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-slate-100">
              <th className="text-left text-xs font-medium text-slate-500 uppercase py-2">Programme Officer</th>
              <th className="text-right text-xs font-medium text-slate-500 uppercase py-2">Total Grants</th>
              <th className="text-right text-xs font-medium text-slate-500 uppercase py-2">Active</th>
              <th className="text-right text-xs font-medium text-slate-500 uppercase py-2">Closed</th>
              <th className="text-right text-xs font-medium text-slate-500 uppercase py-2">Sanctioned</th>
              <th className="text-left text-xs font-medium text-slate-500 uppercase py-2">Themes</th>
              <th className="text-right text-xs font-medium text-slate-500 uppercase py-2">Avg KPI %</th>
            </tr>
          </thead>
          <tbody>
            {poWorkload.map((r, i) => {
              const kpiColor = r.avg_kpi >= 75 ? "text-green-600" : r.avg_kpi >= 50 ? "text-amber-600" : "text-red-600";
              const kpiBar = Math.min(100, r.avg_kpi);
              return (
                <tr key={i} className="border-b border-slate-50 hover:bg-slate-50" data-testid={`po-row-${i}`}>
                  <td className="py-2.5 font-medium text-slate-900 text-sm whitespace-nowrap">{r.po}</td>
                  <td className="py-2.5 text-right text-sm font-semibold">{r.total_grants}</td>
                  <td className="py-2.5 text-right text-xs text-green-600 font-medium">{r.active}</td>
                  <td className="py-2.5 text-right text-xs text-slate-600">{r.closed}</td>
                  <td className="py-2.5 text-right text-xs text-slate-600">{fmtCr(r.allocation_cr)}</td>
                  <td className="py-2.5 text-xs text-slate-500 max-w-[220px]">
                    <div className="flex flex-wrap gap-1">
                      {r.themes.split(', ').filter(Boolean).map((t, ti) => <ThemeChip key={ti} theme={t} />)}
                    </div>
                  </td>
                  <td className="py-2.5 text-right">
                    <div className="flex items-center justify-end gap-2">
                      <div className="w-16 h-1.5 bg-slate-100 rounded-full overflow-hidden">
                        <div className="h-full rounded-full bg-current transition-all"
                          style={{ width: `${kpiBar}%`, color: r.avg_kpi >= 75 ? "#16A34A" : r.avg_kpi >= 50 ? "#D97706" : "#006837" }} />
                      </div>
                      <span className={`text-xs font-bold w-12 text-right ${kpiColor}`}>{r.avg_kpi > 100 ? ">100" : r.avg_kpi}%</span>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </SectionHeader>
  );
}
